// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"ca8c5543","412":"87f9620c","633":"f0bc8cd3","667":"07135923","977":"80a41675"}[chunkId] + ".chunk.js";
};